export default __webpack_public_path__ + "static/media/femimed_pokoj_przygotowawczy_1_thumbnail.dda9d238.webp";